import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { PluggableList } from 'react-markdown/lib/react-markdown';
import ReactMarkdown from 'react-markdown';
import rehypeSlug from 'rehype-slug';
// eslint-disable-next-line max-len
import markdown from '../data/staticPages/i/sustainability-certification-organizations-in-fashion.md';
import Layout from '../components/Layout';
import messages from '../lib/messages.mjs';
import Head from '../components/Head';
import Hero from '../components/Hero';
import generateIntelligencePageBreadcrumbs
  from '../lib/generateIntelligencePageBreadcrumbs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/QT0DWn4Gbaqm8FgOYfF8sstd5cp_8Ijb4qsNr6hka-g/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VzdGFpbmFiaWxpdHlfY2VydGlmaWNhdGVfYmFubmVyX21vYmlsZS5qcGc',
    'https://r.fashionunited.com/U-8MWNpTXrax5u840mAwnlqdSa5i5rFtRMoIOcmGZQA/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VzdGFpbmFiaWxpdHlfY2VydGlmaWNhdGVfYmFubmVyX21vYmlsZS5qcGc',
    'https://r.fashionunited.com/SYR49UfmTuVZEyeOYP-gjfVUx9z7_yzEiWHDgZbcJec/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VzdGFpbmFiaWxpdHlfY2VydGlmaWNhdGVfYmFubmVyX21vYmlsZS5qcGc',
  ],
  desktop: [
    'https://r.fashionunited.com/r_72i1xkn8toinmWsQ852eqUkjRD3Ru7xBaaGCBQnrM/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VzdGFpbmFiaWxpdHlfY2VydGlmaWNhdGVfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/U05xE63-_-Ks3gz93sdLK1H3Se5ol-x0wVY8nqAKzpk/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VzdGFpbmFiaWxpdHlfY2VydGlmaWNhdGVfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/ZUfmF-GmA73Wqc8A0rDY_4FpOlPp8Ey8-R06G2kAGYk/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VzdGFpbmFiaWxpdHlfY2VydGlmaWNhdGVfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/WHRbx5Sy3oEadYdCL6dGIKl-kusF33T0Am-4d29lTm4/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VzdGFpbmFiaWxpdHlfY2VydGlmaWNhdGVfYmFubmVyX2Rlc2t0b3AuanBn',
  ],
};

const SustainabilityCertificationOrganizationsInFashionPage = () => {
  const intl = useIntl();

  const breadcrumbs = generateIntelligencePageBreadcrumbs(
    intl,
    'sustainability-certification-organizations-in-fashion',
    'sustainabilityCertificationOrganizationsInFashion',
  );

  return (
    <>
      <Head
        title={intl.formatMessage(
          messages['sustainabilityCertificationOrganizationsInFashion.title'],
        )}
        description={intl.formatMessage(
          messages['sustainabilityCertificationOrganizationsInFashion.title'],
        )}
      />
      <StaticPageComponent
        content={(
          <ReactMarkdown
            rehypePlugins={
              [rehypeSlug] as PluggableList
            }
          >
            {markdown}
          </ReactMarkdown>
        )}
        title={intl.formatMessage(
          messages['sustainabilityCertificationOrganizationsInFashion.title'],
        )}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

SustainabilityCertificationOrganizationsInFashionPage.getLayout = (
  page: ReactElement,
) => (
  <Layout
    header={(
      <Hero
        imageUrls={headerImageUrls}
        alt="Sustainability Certification Organization banner image"
      />
    )}
  >
    {page}
  </Layout>
);

SustainabilityCertificationOrganizationsInFashionPage
  .getInitialProps = redirectRouteToDomain(
    'sustainability-certification-organizations-in-fashion',
  );

export default SustainabilityCertificationOrganizationsInFashionPage;
